<label class="pt-2">{{ labelText }}</label>
<div cdkDropList class="list" (cdkDropListDropped)="drop($event)">
	<div class="list-item-box" *ngFor="let item of value" cdkDrag>{{ getName(item) }}</div>
</div>
